import axios from "axios";
import { ENV } from "../configs/environment";
import { getActiveLocale } from "../configs/regionalProfile";

const populationApi = axios.create({ baseURL: ENV.API_URL });
export const POPULATION_MEDIA_TYPE =
  "application/vnd.seniorlife.population-trend.v1+json";

export async function fetchPopulationTrends({
  session,
  filters,
  signal,
  scoringVersion = ENV.POPULATION_SCORING_VERSION,
  timezone = Intl.DateTimeFormat().resolvedOptions().timeZone,
}) {
  try {
    const response = await populationApi.get("/v6/population/trends", {
      params: {
        age_band: filters.age,
        gender: filters.sex.toLowerCase(),
        timezone,
      },
      signal,
      headers: {
        Authorization: `Bearer ${session.accessToken}`,
        Accept: POPULATION_MEDIA_TYPE,
        "Accept-Language": getActiveLocale(),
        ...(scoringVersion
          ? { "X-Mobility-Scoring-Version": scoringVersion }
          : {}),
      },
    });
    return response.data;
  } catch (error) {
    if (signal?.aborted || axios.isCancel(error)) throw error;
    const payload = error.response?.data;
    const failure = new Error(payload?.error?.code || "UPSTREAM_UNAVAILABLE");
    failure.code = payload?.error?.code || "UPSTREAM_UNAVAILABLE";
    failure.status = error.response?.status;
    failure.retryable = payload?.error?.retryable ?? true;
    failure.requestId = payload?.request_id;
    failure.details = payload?.error?.details;
    // Only contract/configuration diagnostics; no auth headers or person data.
    console.warn(
      "[Population API] " +
        JSON.stringify({
          code: failure.code,
          status: failure.status,
          requestId: failure.requestId,
          details: failure.details,
        }),
    );
    throw failure;
  }
}
